import React from "react";
import styles from "./Header.module.scss";
import HeaderSlider from "../HeaderSlider/HeaderSlider";

interface SliderImage {
  src1920: string;
  src1440: string;
  src768: string;
  src320: string;
  alt: string;
  imageType?: "full" | "partial";
  translateAlt?: boolean; // Додано опцію перекладу
}

interface HeaderProps {
  images: SliderImage[];
}

const Header: React.FC<HeaderProps> = ({ images }) => {
  const updatedImages = images.map((image) => ({
    ...image,
    imageType: image.imageType || "full",
    translateAlt: image.translateAlt ?? false, // Зберігаємо опцію перекладу
  }));

  return (
    <header className={styles.header}>
      <HeaderSlider images={updatedImages} />
    </header>
  );
};

export default Header;
